// Slow editorial CSS marquee with outlined stroke text.
export default function Marquee({ text = "NO MINIMUM ORDER", separator = "—" }) {
  const items = Array.from({ length: 6 }).map((_, i) => (
    <span key={i} className="inline-flex items-center">
      <span className="font-display uppercase text-[12vw] md:text-[8vw] leading-none stroke-text pr-8 md:pr-16">
        {text}
      </span>
      <span className="text-gold text-[12vw] md:text-[8vw] leading-none pr-8 md:pr-16">{separator}</span>
    </span>
  ));
  return (
    <div className="w-full overflow-hidden py-10 md:py-16 border-y border-white/10 select-none" data-testid="marquee">
      <div className="marquee-track">
        {items}
        {items}
      </div>
    </div>
  );
}
